export default {
	pending: 0,
	approved: 1,
	cancelled: 2
}